import LandingHead from '@/modules/Landing/components/LandingHead.vue'
import LandingTitle from '@/modules/Landing/components/LandingTitle.vue'
import LandingTitleExtended from '@/modules/Landing/components/LandingTitleExtended.vue'
import LandingSubtitle from '@/modules/Landing/components/LandingSubtitle.vue'
import LandingAgeGrid from '@/modules/Landing/components/LandingAgeGrid.vue'
import LandingLottieAnimation from '@/modules/Landing/components/LandingLottieAnimation.vue'
import LandingProgressLoader from '@/modules/Landing/components/LandingProgressLoader.vue'
import LandingImage from '@/modules/Landing/components/LandingImage.vue'
import LandingGift from '@/modules/Landing/components/LandingGift.vue'
import LandingAlert from '@/modules/Landing/components/LandingAlert.vue'
import LandingFooter from '@/modules/Landing/components/LandingFooter.vue'
import LandingVideoAnimation from '@/modules/Landing/components/LandingVideoAnimation.vue'
import LandingLanguageButton from '@/modules/Landing/components/LandingLanguageButton.vue'
import LandingBackgroundImage from '@/modules/Landing/components/LandingBackgroundImage.vue'
import LandingComponentSpacer from '@/modules/Landing/components/LandingComponentSpacer.vue'
import LandingAwardList from '@/modules/Landing/components/LandingAwardList.vue'
import LandingGlp1 from '@/modules/Landing/components/LandingGlp1.vue'
import LandingGenderButtons from '@/modules/Landing/components/LandingGenderButtons.vue'

export default [
	LandingHead,
	LandingTitle,
	LandingTitleExtended,
	LandingSubtitle,
	LandingAgeGrid,
	LandingLottieAnimation,
	LandingProgressLoader,
	LandingImage,
	LandingGift,
	LandingAlert,
	LandingFooter,
	LandingVideoAnimation,
	LandingLanguageButton,
	LandingBackgroundImage,
	LandingComponentSpacer,
	LandingAwardList,
	LandingGlp1,
	LandingGenderButtons,
]
